import { message } from 'antd'
import axios from 'axios'
import { useCallback, useState } from 'react'

import { BASE_URL } from '../../../ini.json'
import { useAppSelector } from '../../redux/hooks'

interface UseUpdateZustavateNoteResult {
  updateNote: (id: string, note: string | null) => Promise<boolean>
  isUpdating: boolean
}

export const useUpdateZustavateNote = (): UseUpdateZustavateNoteResult => {
  const [isUpdating, setIsUpdating] = useState(false)
  const token = useAppSelector(state => state.myProfile.token)

  const updateNote = useCallback(
    async (id: string, note: string | null): Promise<boolean> => {
      if (!token) {
        message.error('Token není k dispozici')
        return false
      }

      setIsUpdating(true)

      try {
        const response = await axios.post(
          `${BASE_URL}/api/zustavate/update/${token}`,
          { id, note }
        )

        if (response.data.success) {
          message.success('Poznámka byla úspěšně aktualizována')
          return true
        } else {
          throw new Error(
            response.data.error || 'Nepodařilo se aktualizovat poznámku'
          )
        }
      } catch (error) {
        message.error(
          error instanceof Error
            ? error.message
            : 'Nepodařilo se aktualizovat poznámku'
        )
        return false
      } finally {
        setIsUpdating(false)
      }
    },
    [token]
  )

  return { updateNote, isUpdating }
}
